const dimensionEnum = {
  /** Date */
  DATE: "BusinessDate.id",
  DATE_YEAR: "BusinessDate.year",
  DATE_SEMESTER: "BusinessDate.semester",
  DATE_QUARTER: "BusinessDate.quarter",
  DATE_MONTH: "BusinessDate.month",
  DATE_WEEK: "BusinessDate.week",
  DATE_DAY: "BusinessDate.day",
  DATE_DAYOFWEEK: "BusinessDate.dayofweek",

  /** Time */
  TIME: "Time.id",
  TIME_PARTOFDAY: "Time.partofday",
  TIME_HOUR: "Time.hour",
  TIME_HALFHOUR: "Time.halfhour",
  TIME_QUARTERHOUR: "Time.quarterhour",

  /** Site */
  SITE: "Site.id",
  SITE_NAME: "Site.label",
  SITE_SITE_CATEGORY: "Site.siteCategoryId",
  SITE_SITE_CATEGORY_NAME: "Site.siteCategoryLabel",
  SITE_FRANCHISE: "Site.franchise",
  SITE_NUMBER: "Site.number",
  SITE_CURRENCY: "Site.currency",

  /** EventType */
  EVENTTYPE: "EventType.id",
  EVENTTYPE_NAME: "EventType.displayNameEvent",
  EVENTTYPE_CATEGORY: "EventType.siteCategoryId",
  EVENTTYPE_CATEGORY_NAME: "EventType.siteCategoryLabel",

  /** Kiosk */
  KIOSK: "Kiosk.id",
  KIOSK_NAME: "Kiosk.name",
  KIOSK_TYPE: "Kiosk.type",
  KIOSK_ISDELETED: "Kiosk.isdeleted",
  KIOSK_CONTRACT: "TPEContract.contract",

  /** Employee */
  EMPLOYEE: "Employee.id",
  EMPLOYEE_FIRSTNAME: "Employee.firstname",
  EMPLOYEE_LASTNAME: "Employee.lastname",
  EMPLOYEE_ROLE: "Employee.role",

  /** Employee Maintenance */
  EMPLOYEE_END_MAINTENANCE_USER: "EmployeeEndMaintenance.username",
  EMPLOYEE_BEGIN_MAINTENANCE_USER: "EmployeeBeginMaintenance.username",

  /** Game */
  GAME: "Game.id",
  GAME_NAME: "Game.name",
  GAME_GAMECATEGORYID: "Game.gamecategoryid",
  // Coût unitaire d'une partie en nombre de tokens
  GAME_TOKENPRICEASDIMENSION: "Game.tokenpriceasdimension",
  GAME_CODE: "Game.code",
  GAME_ISDELETED: "Game.isdeleted",

  /** GameCategory */
  GAMECATEGORY_NAME: "GameCategory.name",

  /** AdjustmentHistory */
  ADJUSTMENTHISTORY_EVENTDATE: "AdjustmentHistory.eventdate",

  /** GameHistory */
  GAMEHISTORY_TAXESPERCENT: "GameHistory.taxespercent",
  GAMEHISTORY_ID: "GameHistory.id",
  GAMEHISTORY_EVENTDATE: "GameHistory.eventdate",
  GAMEHISTORY_DATE: "GameHistory.date",
  GAMEHISTORY_DATETIME: "GameHistory.dateTime",

  /** PurchaseHistory */
  PURCHASEHISTORY: "PurchaseHistory.id",
  PURCHASEHISTORY_NBCARDS: "PurchaseHistory.nbcardsasdimension",
  PURCHASEHISTORY_PRODUCT: "PurchaseHistory.product",
  PURCHASEHISTORY_ISBIRTHDAY: "PurchaseHistory.isbirthday",
  PURCHASEHISTORY_DATETIME: "PurchaseHistory.dateTime",

  /** Purchase History state **/
  PURCHASEHISTORY_CARDTRANSACTIONTYPE: "PurchaseHistoryState.CardTransactionType",

  /** SnackProduct */
  SNACKPRODUCT_ID: "SnackProduct.id",
  SNACKPRODUCT_CATEGORY: "SnackProduct.category",
  SNACKPRODUCT_SUBCATEGORY: "SnackProduct.subcategory",
  SNACKPRODUCT_PRODUCTNAME: "SnackProduct.productname",
  SNACKPRODUCT_TYPE: "SnackProduct.type",

  /** SnackHistory */
  SNACKHISTORY_TAXESPERCENT: "SnackHistory.taxespercent",
  SNACKHISTORY_ISPAYMENTCB: "SnackHistory.ispaymentcb",
  SNACKHISTORY_EVENTDATE: "SnackHistory.eventdate",
  SNACKHISTORY_TOKENAMOUNTPERITEM: "SnackHistory.tokenamountperitem",

  // SmartTouchMaintenance
  SMARTTOUCH_NUMBER: "SmartTouch.serialnumber",
  SMARTTOUCH_ISDELETED: "SmartTouch.isdeleted",

  SMARTTOUCHMAINTENANCE_MAINTENANCEDURATION: "vSmartTouchMaintenance.maintenanceduration",
  SMARTTOUCHMAINTENANCE_MAINTENANCE_DURATION_SUM: "vSmartTouchMaintenance.maintenancedurationsum",
  SMARTTOUCHMAINTENANCE_END_OF_MAINTENANCE: "vSmartTouchMaintenance.endofmaintenance",
  SMARTTOUCHMAINTENANCE_SMARTTOUCH_ID: "vSmartTouchMaintenance.smarttouchid",
  SMARTTOUCHMAINTENANCE_EVENT_DATE: "vSmartTouchMaintenance.eventdate",
  SMARTTOUCHMAINTENANCE_LAST_EVENT_DATE: "vSmartTouchMaintenance.lasteventdate",
  SMARTTOUCHMAINTENANCE_EVENT_DAY: "vSmartTouchMaintenance.eventday",
  SMARTTOUCHMAINTENANCE_EVENT_TIME: "vSmartTouchMaintenance.eventtime",
  SMARTTOUCHMAINTENANCE_LAST_END_MAINTENANCE: "vSmartTouchMaintenance.lastendofmaintenance",
  SMARTTOUCHMAINTENANCE_END_MAINTENANCE_DAY: "vSmartTouchMaintenance.endmaintenanceday",
  SMARTTOUCHMAINTENANCE_END_MAINTENANCE_TIME: "vSmartTouchMaintenance.endmaintenancetime",
  SMARTTOUCHMAINTENANCE_NB_STOPS: "SmartTouch.nbStops",

  /** StaffCard */
  STAFFCARD: "StaffCard.id",
  STAFFCARD_EMPLOYEEID: "StaffCard.EmployeeId",

  /** StaffGameHistory */
  STAFFGAMEHISTORY_CARDNUMBER: "StaffGameHistory.cardnumber",
  STAFFGAMEHISTORY_DATE: "StaffGameHistory.date",
  STAFFGAMEHISTORY_EVENTDATE: "StaffGameHistory.eventdate",

  /** vAccountingRunningTotals */
  VACCOUNTINGRUNNINGTOTALS_ISTYPEPURCHASE: "vAccountingRunningTotals.isTypePurchase",
  VACCOUNTINGRUNNINGTOTALS_SUBTYPE: "vAccountingRunningTotals.subType",
  VACCOUNTINGRUNNINGTOTALS_DATE: "vAccountingRunningTotals.date",

  /** vFullHourlyAccounting */
  VFULLHOURLYACCOUNTING_ISTYPEPURCHASE: "vFullHourlyAccounting.isTypePurchase",
  VFULLHOURLYACCOUNTING_SUBTYPE: "vFullHourlyAccounting.subType",
  VFULLHOURLYACCOUNTING_TAXESPERCENT: "vFullHourlyAccounting.taxesPercent",
  VFULLHOURLYACCOUNTING_ISFREEGAME: "vFullHourlyAccounting.isFreeGame",
  VFULLHOURLYACCOUNTING_DATETIME: "vFullHourlyAccounting.dateTime",

  /** OmniplayEvent */
  OMNIPLAYEVENT_TOTALTTC: "OmniplayEvent.TotalTTC",
  OMNIPLAYEVENT_TOTALHT: "OmniplayEvent.TotalHT",
  OMNIPLAYEVENT_REFERENCE: "OmniplayEvent.Reference",
  OMNIPLAYEVENT_INVOICENUMBER: "OmniplayEvent.InvoiceNumber",
  OMNIPLAYEVENT_ISUPGRADE: "OmniplayEvent.IsUpgrade",
  OMNIPLAYEVENT_CUSTOMERNAME: "OmniplayEvent.CustomerName",
  OMNIPLAYEVENT_CUSTOMEREMAIL: "OmniplayEvent.CustomerEmail",
  OMNIPLAYEVENT_CUSTOMERPHONENUMBER: "OmniplayEvent.CustomerPhoneNumber",
  OMNIPLAYEVENT_ID: "OmniplayEvent.id",
  OMNIPLAYEVENT_EVENTDATE: "OmniplayEvent.EventDate",
  OMNIPLAYEVENT_EVENTTYPE: "OmniplayEvent.EventType",
  OMNIPLAYEVENT_GENERAL: "OmniplayEvent.General",
  OMNIPLAYEVENT_TRANSACTIONS: "OmniplayEvent.Transactions",
  OMNIPLAYEVENT_FORMULA: "OmniplayEvent.Formula",
  OMNIPLAYEVENT_CAKE: "OmniplayEvent.Cake",
  OMNIPLAYEVENT_CHILDBIRTHDATE: "OmniplayEvent.ChildBirthdate",
  OMNIPLAYEVENT_CHILDGENDER: "OmniplayEvent.ChildGender",
  OMNIPLAYEVENT_EVENTBUSINESSDATE: "OmniplayEvent.EventBusinessDate",
  OMNIPLAYEVENT_ORDERBUSINESSDATE: "OmniplayEvent.OrderBusinessDate",
  OMNIPLAYEVENT_ORDERDATE: "OmniplayEvent.OrderDate",
  OMNIPLAYEVENT_NBCARDS: "OmniplayEvent.NbCards",
  OMNIPLAYEVENT_ISBIRTHDAY: "OmniplayEvent.IsBirthday",
  OMNIPLAYEVENT_ISCANCELLED: "OmniplayEvent.IsCancelled",
  OMNIPLAYEVENT_NBTOKENBONUSPERGUEST: "OmniplayEvent.NbTokenBonusPerGuest",
  OMNIPLAYEVENT_NBTOKENPERGUEST: "OmniplayEvent.NbTokenPerGuest",

  /** Formula */
  FORMULA_TITLE: "Formula.title",

  //Valeurs calculées non issues de cubejs
  OMNIPLAYEVENT_AUXILIAIRE: "OmniplayEvent.Auxiliaire",
  OMNIPLAYEVENT_DEBIT: "OmniplayEvent.Debit",
  OMNIPLAYEVENT_CREDIT: "OmniplayEvent.Credit",

  // Azure Cost
  AZURECOST_COST: "AzureCost.cost",
  AZURECOST_DATE: "AzureCost.date",
};

export default dimensionEnum;
